
const AbayomiAdeyemi = () => {

  return (
    <div className="w-full min-h-screen bg-white">
      <div className="relative bg-[#14532d] text-white py-8 md:py-10 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight uppercase tracking-tight">
          Abayomi Adeyemi
          </h2>
        </div>
      </div>


      <div className="max-w-5xl mx-auto px-4 py-8 font-sans text-gray-800">
        <section>
          <div className="max-w-6xl mx-auto p-8 bg-white font-sans text-gray-700">
            <div className="flex flex-col md:flex-row gap-12">

              {/* Left Side: Image */}
              <div className="md:w-1/3">
                <div className="sticky top-24">
                  <div className="relative group">
                    <div className="absolute -inset-1 bg-gradient-to-r from-green-700 to-yellow-400 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
                    <img
                      src="/images/Yomi-Profile-pics.jpg"
                      alt="Kings C. Akuma"
                      className="relative w-full h-auto object-cover rounded-2xl shadow-2xl border-4 border-white"
                    />
                  </div>
                </div>
              </div>

              {/* Right Side: Content */}
              <div className="md:w-2/3">
                {/* Name and Title */}
                <header className="mb-12">
                  <h1 className="text-4xl font-black text-black mb-6 uppercase tracking-tight">PROFILE</h1>
                  <div className="text-lg leading-relaxed space-y-6 text-gray-600 font-medium">
                    <p>
                    A graduate of Mathematics/Statistics with over twenty years of diverse finance and entrepreneurial experience in Corporate & Investment Banking, Stockbrokerage & Asset Management  
                   </p>
                    <p>
                    Yomi Adeyemi is a graduate of Mathematics / Statistics with over twenty years of diverse finance and entrepreneurial experience in Corporate & Investment Banking, Stockbrokerage & Asset Management, Real Estate Development and Strategic Business Turnaround. He is a Fellow of both the Institute of Chartered Accountants of Nigeria and the Chartered Institute of Stockbrokers. He is also a CFA Charterholder and an alumnus of the Lagos Business School Executive Programme. Yomi has PGD certificate in Law (Corporate Law) from the prestigious University of London. He has attended various training programmes in finance, leadership and corporate governance internationally including the Harvard Business School.                    
                    </p>

                    <hr className="border-gray-100 mb-12" />

                    <p>
                    He started his banking career with Merchant Bank of Commerce (MBCOM) in 1998. He left in 2000 to join the Corporate Banking Division of Lead Merchant Bank. Whilst at Lead Bank, he also worked in the Investment Banking Group that participated in various landmark capital market transactions during the privatisation programme of the Federal Government of Nigeria. He was later seconded to the brokerage arm of the Bank (Lead Investments & Securities Limited) to revamp its dwindling fortune.
                    </p>
                    <p>
                    Yomi left the Lead Bank Group in 2004 to work with Core Trust & Investment Limited as Head, Financial Advisory Group, a position he held till 2008, when he led other investors to acquire majority stake in Fortress Capital Limited, a business he has been managing as the CEO since 2008. He was elected as Member to the Council of the Nigerian Stock Exchange to represent the stockbroking community in 2018 and played an active role in the successful demutualisation of the Exchange 2021. He currently serves as Non-Executive Director of Nigerian Exchange Limited.
                    </p>
                    <p>
                    He has other business interests spanning Real Estate, Logistics, Media & Advertising. He currently sits on the board of Livestock Feeds Plc, BDT Properties and Development Company Limited, Exito Logistics Limited and Connect Marketing Services Limited in non-executive capacities.
                    </p>
                    <p>
                    Yomi is a finance expert with decent analytical and problem-solving abilities and a consummate business leader. He actively plays soccer, squash and chess. He volunteers for Life Changers Foundation, a non-profit organisation dedicated to assisting the less privileged using Education, Vocation & Enterprise.
                    </p>
                  </div>
                </header>


              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AbayomiAdeyemi;